import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    '& .MuiCardActionArea-root': {
      textAlign: 'center',
      minHeight: '90px'
    },
    '& .MuiPagination-ul .MuiButtonBase-root': {
      minHeight: 'auto'
    },
    '& .MuiCard-root': {
      backgroundColor: '#e43a00b3',
      color: 'white',
      '&:hover': {
        backgroundColor: '#e43a00cc',
      }
    },
    '& .MuiCardContent-root': {
      padding: theme.spacing(1)
    }
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1)
  },
  searchSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#f8f9fa',
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`
  },
  searchField: {
    width: '100%',
    maxWidth: '500px',
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white'
    }
  },
  searchResults: {
    marginTop: theme.spacing(0.5),
    fontWeight: 500,
    color: theme.palette.primary.main
  },
  orderRow: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(2, 0)
  },
  boldText: { fontFamily: 'VisbyCF-Bold' },
  code: { fontWeight: 600 },
  ctaTitle: {
    fontSize: '18px',
    lineHeight: '20px',
    marginBottom: theme.spacing(1),
    fontFamily: 'VisbyCF-Bold'
  },
  breakWord: { wordBreak: 'break-word', lineHeight: '12px' },
  disabledCard: {
    boxShadow: 'none',
    '& .MuiCardActionArea-root.Mui-disabled': {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.primary.dark
    },
    '&:hover': { opacity: '1 !important' }
  },
  currentStatus: {
    '& .MuiCardActionArea-root.Mui-disabled': {
      borderBottom: `2px solid ${theme.palette.primary.main}`
    }
  },
  statusChip: { marginTop: theme.spacing(1) },
  backButton: { 
    alignSelf: 'flex-start',
    padding: theme.spacing(0.5, 2),
    minHeight: '32px',
    fontSize: '0.875rem',
    height: '32px'
  },
  pagination: { marginTop: theme.spacing(2), display: 'flex', justifyContent: 'center' },
  notesLink: { color: theme.palette.text.secondary },
  hasOrdersContainer: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
  orderCountCopy: { color: theme.palette.text.secondary }
}));

export default useStyles;
